import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faTimes } from "@fortawesome/free-solid-svg-icons";
import { apiSendRemainder } from "../../../../utils/queries";
import { remiderReceiver } from "../../../../utils/common";
import "../../../molecules/BrandModal.css";

export const ReminderModal = ({ toggle, setToggle, account, onSent }) => {
  const close = () => setToggle(false);
  const receiver = remiderReceiver(account?.status);

  const handleConfirm = async () => {
    try {
      const result = await apiSendRemainder(account.id);
      close();
      onSent(result.data);
    } catch (err) {
      close();
    }
  };

  return (
    <Modal isOpen={toggle} toggle={close} className="brand-modal">
      <ModalHeader toggle={close}>Send Reminder</ModalHeader>
      <ModalBody>
        <p className="brand-modal__desc">
          {receiver
            ? <>Send a reminder email to the <strong>{receiver}</strong> for this request.</>
            : "Send a reminder email to the relevant party for this request."
          }
        </p>

        <div className="brand-modal__actions">
          <button type="button" className="brand-modal__btn brand-modal__btn--primary" onClick={handleConfirm}>
            <FontAwesomeIcon icon={faBell} /> Send Reminder
          </button>
          <button type="button" className="brand-modal__btn brand-modal__btn--cancel" onClick={close}>
            <FontAwesomeIcon icon={faTimes} /> Close
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};
